import { ReactNode } from 'react';
import { Scrollable } from '@/common/components/scrollable/Scrollable.tsx';
import Box from '@mui/material/Box';

export interface SidebarContentProps {
  children?: ReactNode;
}

export const SidebarContent = ({ children }: SidebarContentProps) => {
  return (
    <Scrollable>
      <Box p={2}>{children}</Box>
    </Scrollable>
  );
};
